<template>
  <div>
    <van-tabs v-model="active" @click="rel()">
      <van-tab title="首页" name="indexs">
      </van-tab>
      <van-tab title="分账订单" name="index1">
      </van-tab>
      <van-tab title="分账信息" name="index2">
      </van-tab>
    </van-tabs>
    <div class="indexs">
      <div v-if="sure" class="fl1 loads">
        <div class="xql">
          <van-loading size="26px" color="#fff" type="spinner" vertical>加载中...</van-loading>
        </div>
      </div>
      <div class="p1">
        <div class="index_head" style="margin: .6rem 0;">
          <div class="index_head_top">
            <div class="head_top_b">
              <div class="fl1">
                <div class="head_bom mr6">
                  <div class="head_bom_t jcsb">
                    <div class="bom_t_l">今日分账 (元)</div>
                  </div>
                  <div class="head_bom_b fl1">
                    <div class="ib">￥</div>
                    <div class="bom_b_s"><span class="fs15 fw"> {{ money1 }}</span></div>
                  </div>
                </div>
                <div class="head_bom">
                  <div class="head_bom_t jcsb">
                    <div class="bom_t_l">昨日分账 (元)</div>
                  </div>
                  <div class="head_bom_b fl1">
                    <div class="ib">￥</div>
                    <div class="bom_b_s"><span class="fs15 fw"> {{ money2 }}</span></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="head_top_b" style="margin: 1rem 0;">
              <div class="fl1">
                <div class="head_bom mr6">
                  <div class="head_bom_t jcsb">
                    <div class="bom_t_l">本月分账 (元)</div>
                  </div>
                  <div class="head_bom_b fl1">
                    <div class="ib">￥</div>
                    <div class="bom_b_s"><span class="fs15 fw"> {{ money3 }}</span></div>
                  </div>
                </div>
                <div class="head_bom">
                  <div class="head_bom_t jcsb">
                    <div class="bom_t_l">上月分账 (元)</div>
                  </div>
                  <div class="head_bom_b fl1">
                    <div class="ib">￥</div>
                    <div class="bom_b_s"><span class="fs15 fw"> {{ money4 }}</span></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="head_top_b">
              <div class="line" style="background-color: rgba(255, 255, 255, 0.2);"></div>
              <div class="fl1">
                <div class="head_bom mr6">
                  <div class="head_bom_t jcsb">
                    <div class="bom_t_l">累计分账 (元)</div>
                  </div>
                  <div class="head_bom_b fl1">
                    <div class="ib">￥</div>
                    <div class="bom_b_s"><span class="fs15 fw"> {{ money5 }}</span></div>
                  </div>
                </div>
                <div class="head_bom">
                  <div class="head_bom_t jcsb">
                    <div class="bom_t_l">分账小区 (个)</div>
                  </div>
                  <div class="head_bom_b fl1">
                    <div class="bom_b_s"><span class="fs15 fw"> {{ num }}</span></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="fl1" style="justify-content: space-between;">
          <div style="font-size: 1.5rem;margin: 1rem 0;" class="fw">最近10天分账数据</div>
          <div class="fl1" @click="$router.push({
            path: '/mores'
          })">&nbsp; 更多<img src="../../assets/you1.png" class="zImg"></div>
        </div>
        <div class="gain_mx_con" v-for="(v, k) in list" :key="k">
          <div style="margin: .8rem 0;">{{ v.day }}</div>
          <div class="gain_mx_box">
            <div>分账订单：{{ v.order_num }}笔</div>
            <div class="w45">分账金额：<span style="color: #67c23a;">{{ v.amount }}元</span></div>
          </div>
          <div class="fl1 payment-info" v-if="v.settle_state != ''">
            <div>汇付结算：{{ v.settle_amt }}元 </div>
            <img src="../../assets/qwu.png" v-if="v.settle_state == 'S'">
            <img src="../../assets/cw.png" v-if="v.settle_state == 'F'">
            <img src="../../assets/jz.png" class="rotate" v-if="v.settle_state == 'P'">
          </div>
          <div class="gain_mx_box" v-if="v.settle_state == 'F'">失败原因：{{ v.settle_msg }}</div>
        </div>
        <p style="text-align: center;color: #999;margin-bottom: 1rem;" v-if="list.length != 0">没有数据了</p>
        <img src="../../assets/ww.png" style="width: 100%;" v-else>
      </div>
    </div>
  </div>
</template>

<script>
  import { Toast } from 'vant'
  import { getData, getDataList } from "../../api/index"
  export default {
    data() {
      return {
        list: [],
        active: 'indexs',
        endDate: '',
        money1: '',
        sure: true,
        money2: '',
        money3: '',
        money4: '',
        money5: '',
        num: '',
      };
    },
    methods: {
      rel() {
        this.$router.push({ path: this.active });
      },
      // 获取分账统计数据
      async getDates() {
        let data = await getData({ member_id: localStorage.getItem("MemberId"), mch_id: localStorage.getItem("MchId"), vender_id: localStorage.getItem(
            "VenderId") });
        if (data.code == 1) {
          this.num = data.data.district_num; //站点数
          this.money5 = data.data.total_money; //总金额
          this.money1 = data.data.profit_day; //本日分账
          this.money3 = data.data.profit_month; //本月分账
          this.money2 = data.data.profit_yesterday; //昨日分账
          this.money4 = data.data.profit_last_month; //上个月分账
        }
        let data1 = await getDataList({ member_id: localStorage.getItem("MemberId"), mch_id: localStorage.getItem("MchId"), vender_id: localStorage.getItem(
            "VenderId"), nextdate: this.endDate });
        if (data1.code == 1) {
          this.list = data1.data.list;
          this.endDate = data1.data.nextdate;
          this.sure = false;
        }
      }
    },
    mounted() {
      this.getDates();
      this.active = this.$route.name
    }
  }
</script>
<style lang="less">
  .zImg {
    margin-left: .4rem;
    height: 1rem;
  }

  .payment-info {
    margin: .8rem 0;
    display: flex;
    align-items: center;
  }

  .payment-info img {
    width: 1.6rem;
    margin-left: .3rem;
  }

  @keyframes rotateAnimation {
    from {
      transform: rotate(0deg);
    }

    to {
      transform: rotate(360deg);
    }
  }

  .rotate {
    animation: rotateAnimation 3s linear infinite;
  }

  .fw {
    font-weight: 700;
  }

  .indexs {
    // height: 100vh;
    background-color: #f2f3f5;

    .h1 {
      height: 1rem;
    }

    .gain_mx_con {
      padding: .6rem 1.6rem .6rem;
      background-color: #fff;
      border-radius: .6rem;
      margin: .8rem 0;

      .gain_mx_box {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 1rem 0;
        font-size: 1.5rem;
      }

      .w45 {
        width: 45%;
      }
    }

    .p1 {
      padding: 0 1rem;
    }

    .fsc {
      font-size: 1.2rem;
      color: #e9e9e9;
    }

    .tt_top {
      width: 2.4rem;
      height: 4rem;

      img {
        width: 1.7rem;
        margin-top: 1rem;
      }
    }

    .fsc1 {
      font-size: 1.3rem;
      color: #e9e9e9;
    }

    .mt_5 {
      margin-top: 0.5rem;
    }

    .fl {
      display: flex;
      align-items: flex-end;
    }

    .seamless {
      height: 3rem;
      line-height: 3rem;
    }

    .blue {
      background: url(../../assets/index/bg.png) 0 0 no-repeat;
      background-size: 100% 100%;
      margin-top: .4rem;
      padding: 1.5rem 1.5rem 1rem !important;
    }

    .index_head_top {
      background: url(../../assets/index/bgs.png) 0 0 no-repeat;
      background-size: 100% 100%;
      padding: 1.5rem 1.5rem 1rem;

      .head_top_t {
        height: 1.8rem;

        .top_t_l {
          color: #fff;
        }

        .top_t_r {

          color: #fff;
        }
      }

      .head_top_b {
        color: #fff;

        .top_b_l {
          margin-top: .8rem;
          font-size: 2.2rem;
        }

        .top_b_r {

          text-align: right;

          .top_b_r_text {
            width: 7rem;
          }
        }
      }
    }

    .head_bom {
      width: 45%;
      line-height: 1.7;

      .head_bom_t {
        .bom_t_l {
          color: #fff;
        }

        .bom_t_r {
          img {
            width: 2.4rem;
          }
        }
      }

      .head_bom_b {
        color: #fff;
        align-items: first baseline !important;
      }
    }

    .index_tt {
      background-color: #fff;
      border-radius: .4rem;
      margin: .6rem 0;
      height: 4rem;
      color: #a5a7b1;

      .tt_box {
        display: flex;
        align-items: center;
        margin: 0 1rem;
      }

      .tt_text {
        margin-left: .4rem;
        overflow: hidden;
        width: 78%;
      }
    }

    .index_sj {
      background: #fff;
      box-shadow: 0rem .1rem .4rem .1rem rgba(0, 0, 0, 0.05);
      border-radius: .6rem;
      padding: 1.6rem;
      margin: .8rem 0;

      .index_sj_box {
        width: 50%;
        display: flex;

        .box_img {
          width: 3rem;
          height: 3rem;
        }

        .sj_box_img {
          margin: 0 1rem;
        }

        .text1 {
          margin-bottom: .4rem;
          color: #a5a7b1;
        }

        .sj_box_text {
          margin-top: .4rem;
        }

        .text2 {
          font-size: 1.5rem;
          font-weight: 600;
          color: #444;
        }
      }
    }

    .index_tu {
      height: 16rem;
      background: #fff;
      box-shadow: 0rem .1rem .2rem 0rem rgba(0, 0, 0, 0.06),
        0rem .1rem .2rem 0rem rgba(0, 0, 0, 0.06);
      border-radius: .6rem;

    }

    .ib {
      display: inline-block;
    }

    .jcsb {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .fs20 {
      font-size: 2rem;
    }

    .mr6 {
      margin-right: .6rem;
    }

    .fs18 {
      font-size: 1.8rem;
    }

    .fs15 {
      font-size: 1.6rem;
    }

    .mg {
      margin: 1.3rem 0;
    }

    canvas {
      width: 98% !important;
    }
  }
</style>